import classNames from 'classnames'
import { Icon, Typography } from 'shared/ui'
import styles from './styles.module.scss'

export const SendSms = () => {
  return (
    <div className={classNames(styles.content)}>
      <div className={classNames(styles.wrapIcon)}>
        <Icon icon={'messageTextCircle02'} fontSize={16} />
      </div>
      <Typography
        tag={'div'}
        variant={'body-sm-regular'}
        color={'var(--content-primary-primary)'}
        ariaLabel={'send_sms'}
      >
        Send SMS
      </Typography>
    </div>
  )
}
